import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserDetailsFacade, OfflineFacade } from '@shared/state/facades';
import { Observable, combineLatest, take, mergeMap, of } from 'rxjs';
import cloneDeep from 'lodash.clonedeep';

import { DailyStockService } from '..';

@UntilDestroy()
@Injectable()
export class DprConsumableOfflineService {
  constructor(
    private dailyStockService: DailyStockService,
    private userDetailsFacade: UserDetailsFacade,
    private offlineFacade: OfflineFacade
  ) {}

  updateDependentConsumablePrevValues(startDate: Date): Observable<boolean> {
    return combineLatest([
      this.userDetailsFacade.query.projectSetup$,
      this.offlineFacade.query.combinedDprDetailsList$,
    ]).pipe(
      untilDestroyed(this),
      take(1),
      mergeMap(([projectSetup, dprDetailsList]) => {
        const consumableList = projectSetup?.consumableList ?? [];
        const dprDetailsCopy = cloneDeep(dprDetailsList);
        consumableList.forEach((consumable) => {
          const items = dprDetailsCopy
            .filter((x) => new Date(x.dprDateTime) >= new Date(startDate))
            .sort((a, b) => {
              return (
                new Date(a.dprDateTime).valueOf() -
                new Date(b.dprDateTime).valueOf()
              );
            });

          for (let i = 1; i < items.length; i++) {
            const prevItem = (
              items[i - 1].dprConsumable.dprConsumableDetails ?? []
            ).find((x) => x.consumableId === consumable.id);
            const currentItem = (
              items[i].dprConsumable.dprConsumableDetails ?? []
            ).find((x) => x.consumableId === consumable.id);

            if (prevItem && currentItem) {
              const previous = prevItem.previous || 0;
              const today = prevItem.today || 0;
              currentItem.previous = Number((previous + today).toFixed(2));

              currentItem.dailyStockDetails =
                this.dailyStockService.onPreviousDayChanged(
                  prevItem.dailyStockDetails,
                  currentItem,
                  currentItem.dailyStockDetails
                );

              this.offlineFacade.setDprDetails(cloneDeep(items[i]));
            }
          }
        });
        return of(true);
      })
    );
  }
}
